import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import { authReducer as auth } from './auth.reducer';
import { bookletListReducer as bookletList } from './booklet-list.reducer';
import { bookletArchiveReducer as bookletArchive } from './booklet-archive.reducer';
import { bookletTagsReducer as bookletTags } from './booklet-tags.reducer';
import { bookletReducer as booklet } from './booklet.reducer';
import { usersReducer as users } from './users.reducer';
import { userReducer as user } from './user.reducer';
import { loadingReducer as loader } from './loading.reducer';
import { searchReducer as search } from './search.reducer';
import { searchInputReducer as searchInput } from './search-input.reducer';
import { sharesReducer as shares } from './shares.reducer';
import { eventsReducer as events } from './events.reducer';
import { folderReducer as folder } from './folder.reducer';
import { extensionReducer as extension } from './extension.reducer';
import { extensionsReducer as extensions } from './extensions.reducer';
import { presentationReducer as presentation } from './presentation.reducer';
import { presentationsReducer as presentations } from './presentations.reducer';
import { mediaHubReducer as mediaHub } from './mediaHub.reducer';

const reducer = combineReducers({
  auth,
  bookletList,
  bookletArchive,
  bookletTags,
  booklet,
  users,
  user,
  router,
  loader,
  search,
  searchInput,
  shares,
  events,
  folder,
  extension,
  extensions,
  presentation,
  presentations,
  mediaHub,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/reducer.js